import { useSelector } from "react-redux";

import { RootState } from "~/state/store";

export default function useSessionHasExpired() {
  const { sessionExpired } = useSelector((state: RootState) => state.user);

  return sessionExpired;
}
